import {
    GET_SOCIETY_BANKS, GET_SOCIETY_BANK_DETAILS,
    CREATE_SOCIETY_BANK, UPDATE_SOCIETY_BANK, DELETE_SOCIETY_BANK,
    GET_BANK_JOURNAL_ENTRIES, GET_SOCIETY_BANKS_DROPDOWN,
} from '../../index.types'

export function getSocietyBanks(data) {
    return { type: GET_SOCIETY_BANKS, data }
}

export function getSocietyBankDetails(data) {
    return { type: GET_SOCIETY_BANK_DETAILS, data }
}

export function createSocietyBank(data) {
    return { type: CREATE_SOCIETY_BANK, data }
}

export function updateSocietyBank(data) {
    return { type: UPDATE_SOCIETY_BANK, data }
}

export function deleteSocietyBank(data) {
    return { type: DELETE_SOCIETY_BANK, data }
}

export function getBankJournalEntries(data) {
    return { type: GET_BANK_JOURNAL_ENTRIES, data }
}

export function getSocietyBanksDropdown(data) {
    return { type: GET_SOCIETY_BANKS_DROPDOWN, data }
}
